import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  Chip
} from '@mui/material';

const WorkflowSelector = ({ workflows, selectedWorkflow, onWorkflowChange }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        🤖 Select Workflow
      </Typography>
      
      <FormControl fullWidth>
        <Select
          value={selectedWorkflow}
          onChange={(e) => onWorkflowChange(e.target.value)}
          displayEmpty
        >
          {Object.entries(workflows).map(([key, workflow]) => (
            <MenuItem key={key} value={key}>
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Typography sx={{ mr: 1 }}>
                  {workflow.icon}
                </Typography>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body1">
                    {workflow.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {workflow.description}
                  </Typography>
                </Box>
                {workflow.status === 'planned' && (
                  <Chip 
                    label="Planned" 
                    size="small" 
                    color="warning" 
                    sx={{ ml: 1 }}
                  />
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      {workflows[selectedWorkflow]?.status === 'planned' && (
        <Box sx={{ mt: 2, p: 1, bgcolor: 'warning.light', borderRadius: 1 }}>
          <Typography variant="caption" color="warning.dark">
            ⚠️ This workflow is planned but not yet implemented
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default WorkflowSelector;